import { useEffect, useState } from "react";
import { OverlayProvider } from "@react-aria/overlays";
import ErrorBoundary from "./components/ErrorBoundary";
import { LoadingOverlay } from "./components/Loading";
import Routes from "./routes/Routes";
import { fetchAdaptiveBaatToken } from "./utils/baat";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAdaptiveBaatToken()
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  return (
    <OverlayProvider>
      <ErrorBoundary
        errorComponent={
          <>
            <h1>😥 Something went wrong</h1>
            <p>Reload the page to try again.</p>
          </>
        }
      >
        {loading ? <LoadingOverlay /> : <Routes />}
      </ErrorBoundary>
    </OverlayProvider>
  );
}

export default App;
